"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayUI = void 0;
const create_game_menu_1 = require("./elements/create-game-menu");
const create_answer_board_1 = require("./elements/create-answer-board");
const create_jumpled_strings_1 = require("./elements/create-jumpled-strings");
require("./playUI.scss");
const get_data_1 = require("../../../../utils/get-data");
const gameplay_1 = require("./gameplay");
class PlayUI {
    constructor(id) {
        this.playHTML = document.createElement('div');
        this.playHTML.id = id;
        this.gameMenu = new create_game_menu_1.GameMenu('game-menu');
        this.sourceDataBlock = new create_jumpled_strings_1.JumpledStrings('source-data-block');
        this.answerBoard = new create_answer_board_1.AnswerBoard('output-data-block');
    }
    render(level, round) {
        PlayUI.sourceStringArray = [];
        PlayUI.roundStringNumber = 0;
        if (level !== PlayUI.level) {
            PlayUI.level = level;
            (0, get_data_1.GetLevel)(`https://raw.githubusercontent.com/rolling-scopes-school/rss-puzzle-data/ee4dc7be8759183c549b49bc895e6004fc0f05a2/data/wordCollection${level}.json`);
        }
        setTimeout(() => {
            const roundArray = get_data_1.dataLevel;
            const stringsArray = roundArray[round].words;
            stringsArray.forEach((str) => {
                PlayUI.sourceStringArray.push(str.textExample);
            });
            const sourceDataBlock = this.sourceDataBlock.render(`<${PlayUI.sourceStringArray[PlayUI.roundStringNumber]}>`);
            this.playHTML.append(sourceDataBlock);
            (0, gameplay_1.saveStateLevel)(level, round);
        }, 500);
        const gameMenu = this.gameMenu.render();
        gameMenu.classList.add('disabled');
        const outputDataBlock = this.answerBoard.render();
        this.playHTML.append(gameMenu);
        this.playHTML.append(outputDataBlock);
        return this.playHTML;
    }
}
exports.PlayUI = PlayUI;
PlayUI.sourceStringArray = [];
PlayUI.souurceRoundArray = {};
PlayUI.roundStringNumber = 0;
